// components/organization/OrgRecentActivity.jsx
import { useTranslation } from "react-i18next"; // ← اضافه شده

const OrgRecentActivity = ({ exams }) => {
  const { t } = useTranslation(); // ← اضافه شده

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        {t('org_recent_activity.title')}
      </h3>
      {exams.length ? (
        <ul className="text-sm">
          {exams.map((exam, i) => (
            <li
              key={i}
              className={`flex justify-between items-center border-b border-gray-200 p-2 ${
                i % 2 ? "bg-slate-100" : "bg-white"
              }`}
            >
              <span className="font-medium text-gray-800">{exam.title}</span>
              <span className="text-xs px-2 py-1 bg-indigo-100 rounded-full text-gray-600">
                {exam.date}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 text-sm">{t('org_recent_activity.empty_state_message')}</p>
      )}
    </div>
  );
};

export default OrgRecentActivity;